module.exports = __webpack_public_path__ + "media/images/icons/icon-email-circle-d598e26e2d3e07dae628fc2d07189d16.svg";